import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDiscountParent implements BaseEnumType {
  private static allValues: EnumDiscountParent[] = []; // make sure this is top-most
  
  public static none = new EnumDiscountParent(0, "None", "enum_discount_parent_none");
  public static group = new EnumDiscountParent(1, "Group", "enum_discount_parent_group");
  public static outlet = new EnumDiscountParent(2, "Outlet", "enum_discount_parent_outlet");
  public static priceList = new EnumDiscountParent(3, "PriceList", "enum_discount_parent_price_list");
  public static stockItem = new EnumDiscountParent(4, "StockItem", "enum_discount_parent_stock_item");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDiscountParent.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDiscountParent.none; }
  public isGroup() { return this === EnumDiscountParent.group; }
  public isOutlet() { return this === EnumDiscountParent.outlet; }
  public isPriceList() { return this === EnumDiscountParent.priceList; }
  public isStockItem() { return this === EnumDiscountParent.stockItem; }

  public static getValues(): readonly EnumDiscountParent[] {
    return EnumDiscountParent.allValues;
  }

  public static getValuesExcept0(): readonly EnumDiscountParent[] {
    return EnumDiscountParent.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDiscountParent {
    const found = EnumDiscountParent.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDiscountParent - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDiscountParent): EnumDiscountParent {
    const found = name ? EnumDiscountParent.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDiscountParent - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDiscountParent>): boolean {
    return this.key === other?.key;
  }
}